import Button from './Button'
import './CenterPopup.css'

export default function CenterPopup({ open, template, onConfirm, onCancel }) {
  if (!open || !template) return null
  const hasCancel = Boolean(template.cancelLabel)
  const hasConfirm = Boolean(template.confirmLabel)
  const hasActions = hasCancel || hasConfirm

  return (
    <div className="popup-backdrop" role="dialog" aria-modal="true">
      <div className="popup-card">
        {template.iconImage ? (
          <div className="popup-icon popup-icon-image-wrap" aria-hidden="true">
            <img src={template.iconImage} alt="" className="popup-icon-image" />
          </div>
        ) : template.icon ? (
          <div className="popup-icon" aria-hidden="true">{template.icon}</div>
        ) : null}
        <p className="popup-title">{template.title}</p>
        <p className="popup-subtitle">{template.subtitle}</p>
        <p className="popup-message">{template.message}</p>
        {hasActions ? (
          <div className="popup-actions">
            {hasCancel ? (
            <Button variant="ghost" className="popup-btn" onClick={onCancel}>{template.cancelLabel}</Button>
            ) : null}
            {hasConfirm ? (
              <Button variant="primary" className="popup-btn" onClick={onConfirm}>{template.confirmLabel}</Button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  )
}
